<body class="auth auth-login dark-mode" cz-shortcut-listen="true">
    <div class="body-wrapper auth-wrapper d-flex align-items-stretch">
        <div class="d-flex flex-grow flex-column-reverse flex-sm-row w-100">
            <div class="auth-bg py-5 py-sm-0 col-sm-8">
            </div>
            <div class="auth-panel-wrapper col">
                <div class="auth-panel py-5">
                    <img src="./assets/logo-site.png" class="auth-logo mx-auto" style="height:auto;">
                    <form id="Form" [formGroup]="form">
                        <input type="hidden" name="_token" value="lHMm4mJ4I6kOigqCnOWbliWLoNsFDjSu87T6zN10">
                        <div class="form-group">
                            <label class="control-label text-left">
                                Login
                            </label>
                            <input type="text" formControlName="userName" matInput class="form-control">

                        </div>
                        <div class="form-group py-4">
                            <label class="control-label text-left">
                                Senha
                            </label>
                            <input type="password" formControlName="password" matInput class="form-control">

                        </div>
                        <div class="form-group pb-4">
                            <label class="form-check-label">
                                <input type="checkbox" name="Acesso[lembrar]" id="AcessoLembrar"
                                    class="form-check-input" value="1">
                                <i class="input-helper"></i>Lembrar de mim
                            </label>
                        </div>
                        <button type="submit" class="btn btn-lg auth-btn" id="botao-enviar" (click)="login()">
                            Entrar
                        </button>
                        <p class="tip text-center mt-2">
                            <!-- <a href="/auth/esqueci_minha_senha" class="auth-link">
                                Esqueceu sua senha?
                            </a> -->
                            <label class="label-recuperar" (click)="abrirRecuperar()">Esqueceu sua senha?</label>
                        </p>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="loading">
        <div class="spinner-wrapper">
            <div class="spinner"></div>
        </div>
    </div>


</body>

<!-- <div id="body">
    <div class="auth-bg py-5 py-sm-0 col-sm-6 cz-color-2696481">
    </div>
    <mat-card class="login mat-elevation-z8">
        <mat-card-content>

            <form [formGroup]="form">
                E-mail
                <div style="background-color: #121212; margin: 10px 0px 10px 0px;">
                    <input formControlName="userName" matInput>
                    <mat-icon matSuffix>account_circle</mat-icon>
                </div>
                Senha
                <div style="background-color: #121212; margin: 10px 0px 10px 0px;">
                    <input formControlName="password" matInput [type]="pwdhide ? 'password' : 'text'">
                    <mat-icon matSuffix (click)="pwdhide = !pwdhide">{{pwdhide ? 'visibility_off' :
                        'visibility'}}</mat-icon>
                </div>

                <div class="form-check checkbox-rounded checkbox-cerulean-blue-filled">
                    <input type="checkbox" class="form-check-input" style="display: flex; align-items: center;"
                        id="rememberUser">
                    <label class="form-check-label" style="display: flex; align-items: center;"
                        for="rememberUser">Lembrar usuário</label>
                </div>
            </form>
            <div class="flex-column">
                <button class="botao-azul" id="botao-enviar" (click)="login()"
                    [disabled]="form.get('password').errors || form.get('userName').errors">
                    Entrar
                </button>
            </div>
            <div class="flex-column">
                <button mat-button color="warn" (click)="forgotPassword()" [disabled]="form.get('userName').errors">
                    Esqueci minha senha
                </button>
            </div>
        </mat-card-content>
    </mat-card>
    <mat-form-field></mat-form-field>
</div> -->